import axios, { AxiosError } from "axios"
import { LIST_PATH, EXCEPTION_PATH } from "../../constants/paths"
import { requestInterceptorSuccessCredentials, requestInterceptorErrorSecurityCredentials, responseInterceptorSuccessCredentials, responseInterceptorErrorCredentials } from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getExceptionsService = async () => {
  try {
    const result = await instance.get(EXCEPTION_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createExceptionService = async (exception: any) => {
  try {
    const result = await instance.post(EXCEPTION_PATH, exception)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteExceptionService = async (id: any) => {
  try {
    const result = await instance.delete(EXCEPTION_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editExceptionService = async (id: number, exception: any) => {
  try {
    const result = await instance.put(EXCEPTION_PATH + `/${id}`, exception)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
